import type { EnvironmentProviders, Provider } from '@angular/core';
import { provideNgxMask } from 'ngx-mask';

export function provideLeadGenMask(): Provider | EnvironmentProviders {
  return provideNgxMask({ validation: false });
}
